export enum TrackingEvent {
  SIGNUP = "signup",

  BEGIN_CHECKOUT = "begin_checkout",
  ADD_SHIPPING_INFO = "add_shipping_info",
  ADD_PAYMENT_INFO = "add_payment_info",
  PURCHASE = "initiated_payment",
  PURCHASE_AFTER = "purchase",
}
